import React from 'react'

interface MediumBadgeButtonProps {
  label: string
  onClick?: () => void
  variant?: 'default' | 'inverse'
  className?: string
}

const MediumBadgeButton: React.FC<MediumBadgeButtonProps> = ({
  label,
  onClick,
  variant = 'default',
  className = '',
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        h-40px
        rounded-8px
        flex items-center justify-center
        transition-all
        font-pretendard font-bold text-14px leading-20px text-center
        ${
          variant === 'default' &&
          'bg-brown-80%-main text-backgroundPrimary'
        }
        ${
          variant === 'inverse' &&
          'bg-472410-10% text-brown-80%-main'
        }
        ${className}
      `}
    >
      {label}
    </button>
  )
}

export default MediumBadgeButton
